import { Vector3, type Box3, type PerspectiveCamera } from "three";

interface SplatMeshBounds {
  computeBoundingBox(applySceneTransforms?: boolean): Box3;
}

export interface FrameableSplatViewer {
  camera: PerspectiveCamera;
  controls: {
    target: Vector3;
    update(): void;
  };
  getSplatMesh(): SplatMeshBounds;
}

export function frameSplatScene(viewer: FrameableSplatViewer): boolean {
  const bounds = viewer.getSplatMesh().computeBoundingBox(true);
  if (bounds.isEmpty()) return false;

  const center = bounds.getCenter(new Vector3());
  const size = bounds.getSize(new Vector3());
  const maxDimension = Math.max(size.x, size.y, size.z);
  if (!Number.isFinite(maxDimension) || maxDimension <= 0) return false;

  const distance = maxDimension * 1.5;
  viewer.camera.position.set(center.x, center.y - distance, center.z + distance * 0.35);
  viewer.camera.near = Math.max(distance / 1000, 0.01);
  viewer.camera.far = Math.max(distance * 10, 1000);
  viewer.camera.lookAt(center);
  viewer.camera.updateProjectionMatrix();
  viewer.controls.target.copy(center);
  viewer.controls.update();
  return true;
}
